import { call, put, takeEvery, select } from "redux-saga/effects";
import { AxiosDefaults } from "axios";
import * as actions from "actions";
import * as api from "api";
import * as Types from "Types";

function* temp(action: any) {
   const { v_name, hp, email, paymethod, acount_holder, bank_name, should_cash_receipt } = action.payload;

   const parameters = {
      name: v_name,
      hp,
      email,
      paymethod,
      msg: `<div>paymethod: ${paymethod} </div><div>예금주: ${acount_holder}</div><div>은행: ${bank_name}</div><div>현금 영수증 여부: ${should_cash_receipt}</div>`,
      pid: 5,
      count: 1,
      dlv_price: 0,
      total: 22000,
      optlist: [],
   };

   const status: string = yield select(function (state: Types.SagaStates) {
      return state.order.temp.status;
   });
   if (status === api.statuses.pending) return;
   try {
      yield put({
         type: actions.order.temp.send,
      });

      // const { data } = yield call([axios, "post"], testUri, { pageNum: 1, pageSize: 15 });
      // const response: Types.Api.Response = yield call(instance.get, testUri);
      const response: AxiosDefaults<any> = yield call(api.instance.post, `${api.order.temp.uri}`, parameters);

      // eslint-disable-next-line eqeqeq
      yield put({
         type: actions.order.temp.success,
         payload: response,
      });
   } catch (error) {
      yield put({
         type: actions.order.temp.fail,
         payload: error,
      });
   }
}

export function* tempSaga() {
   yield takeEvery(actions.order.temp.call, temp);
}
